import { axiosInstance } from "api/axios-config/axios-config";
import { GetInpsectionNotes } from "api/models/request/inspection-note/inspection-note";
import { Pagination } from "api/models/response/pagination";
import { DEFAULT_VOUCHER_SLICE_SIZE } from "commons/constants";
import { IInspectionNoteProperties } from "mobx-stores/_models/inspection-note/inspection-note";

class InspectionNoteBusiness {
  url = "";
  constructor(url: string) {
    this.url = url;
  }

  public getLists = async (request: GetInpsectionNotes) => {
    try {
      var res = await axiosInstance.get<Pagination<IInspectionNoteProperties>>(
        this.url,
        {
          params: request,
        },
      );
      return res.data;
    } catch (error) {
      console.error("Fail get lists", error);
      return Promise.reject(error);
    }
  };

  public searchInspectionNotes = async (keyword: string) => {
    const res = await this.getLists({
      filter: keyword,
      maxResultCount: DEFAULT_VOUCHER_SLICE_SIZE,
      skipCount: 0,
      sorting: "",
    });

    return res;
  };
}

export const inspectionNoteBusiness = new InspectionNoteBusiness(
  "/api/app/inspection-note",
);
